import { globalConstants } from "../../constants";

const initialState = {
  spinnerActions: [],
  saveChanges: false,
  isConfirmationModal: false,
  selectedRowId: null,
};

export const systemReducer = (state = initialState, action) => {
  switch (action.type) {
    case globalConstants.SPINNER_ACTIVATE:
      return {
        ...state,
        spinnerActions: [...state.spinnerActions, action.data],
      };
    case globalConstants.SPINNER_DIACTIVATE:
      return {
        ...state,
        spinnerActions: state.spinnerActions.filter((f) => f !== action.data),
      };
    case globalConstants.SET_SAVE_CHANGES:
      return {
        ...state,
        saveChanges: action.data,
      };
    case globalConstants.IS_CONFORMATION_MODAL:
      return {
        ...state,
        isConfirmationModal: action.data,
      };
    case globalConstants.SET_SELECTED_ROW_ID:
      return {
        ...state,
        selectedRowId: action.data,
      };
    default:
      return state;
  }
};
